'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorMergeType = function EditorMergeType(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z' })
  );
};
EditorMergeType = (0, _pure2.default)(EditorMergeType);
EditorMergeType.displayName = 'EditorMergeType';
EditorMergeType.muiName = 'SvgIcon';

exports.default = EditorMergeType;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/editor/merge-type.js
 ** module id = 1939
 ** module chunks = 0
 **/